import { modelOptions, post, prop } from "@typegoose/typegoose";
import { getZodSchemaFromClass, validate } from "../../../zod-decorator/index.js";
import { ENTITY_NAME_MAX_LENGTH, emptyableEntityNameZodValidator } from "../../commonZodValidators/entityName.js";
import { addSchemaKeyHook, getDefaultSchemaOptions, SchemaBase, SchemaConstructorArgs } from "../../schemaBase.js";
import type { PumpSpecifierFieldsWithDefaults, PumpSpecifierSchemaTypes } from "../../types/pumpSpecifier.d.js";
import type { DtoValidatorTypes } from "../../validatableClass.js";

const SCHEMA_KEY = "PumpSpecifier" as const;

@modelOptions({ schemaOptions: { ...getDefaultSchemaOptions(SCHEMA_KEY) } })
@post<SchemaBase<PumpSpecifier>>(...addSchemaKeyHook(SCHEMA_KEY))
export class PumpSpecifier extends SchemaBase<PumpSpecifier, PumpSpecifierFieldsWithDefaults> {
    static schemaKey = SCHEMA_KEY;
    @validate({ schemaKey: SCHEMA_KEY })
    readonly schemaKey = SCHEMA_KEY;

    @validate({ zodValidator: emptyableEntityNameZodValidator })
    @prop({ type: () => String, required: false, maxlength: ENTITY_NAME_MAX_LENGTH })
    public pumpName?: string;

    static getters = {} as const satisfies Record<string, (self: PumpSpecifier) => any>;

    static utilities = {} as const satisfies Record<string, (...args: any) => any>;

    static dtoValidators: DtoValidatorTypes<PumpSpecifierSchemaTypes>;

    constructor(properties?: SchemaConstructorArgs<PumpSpecifier, PumpSpecifierFieldsWithDefaults>) {
        super(properties);
        Object.assign(this, properties);
    }
}

PumpSpecifier.dtoValidators = getZodSchemaFromClass(
    PumpSpecifier,
) as unknown as DtoValidatorTypes<PumpSpecifierSchemaTypes>;
